import Vue from "vue";

export default {
  state: {
    isKiosk: false,
    showKioskSplashOnHome: true,
    hideSetupButton: false,

    isAndroidKiosk: false,
    androidKioskUrl: '',
    androidJsonAppConfig: {},
    androidBuildTime: '',
    bluetoothDevices: '',
    allPaymentStores: '',
    softposTerminalState: 'N/A',
    storePicked: {storeId: '', storeName: ''},
    printerLog: '',
    bonImagePreviewUrl0: '',
    bonImagePreviewUrl1: '',
    bonImagePreviewUrl2:'',
  },
  actions: {},
  mutations: {
    storePicked(state, v) {
      return state.storePicked = v;
    },
    softposTerminalState(state, v) {
      return state.softposTerminalState = v;
    },
    setIsKiosk(state, v) {
      return state.isKiosk = !!v;
    },
    setShowKioskSplashOnHome(state, v) {
      return state.showKioskSplashOnHome = !!v;
    },
    hideSetupButton(state, v) {
      Vue.ls.set('hideSetupButton', !!v);
      return state.hideSetupButton = !!v;
    },

    androidBuildTime(state, v) {
      state.androidBuildTime = v;
    },

    bluetoothDevices(state, v) {
      state.bluetoothDevices = v;
    },

    allPaymentStores(state, v) {
      state.allPaymentStores = v;
    },

    isAndroidKiosk(state, v) {
      state.isAndroidKiosk = v;
    },
    androidJsonAppConfig(state, v) {
      try{
        state.androidJsonAppConfig = JSON.parse(v || '{}');
      }catch(err){
        state.androidJsonAppConfig = {};
      }
    },
    androidKioskUrl(state, v) {
      state.androidKioskUrl = v;
    },
    printerLog(state, v) {
      state.printerLog = v;
    },
    bonImagePreviewUrl0(state, v) {
      state.bonImagePreviewUrl0 = v;
    },
    bonImagePreviewUrl1(state, v) {
      state.bonImagePreviewUrl1 = v;
    },
    bonImagePreviewUrl2(state, v) {
      state.bonImagePreviewUrl2 = v;
    },
  },
  getters: {
    bonImagePreviewUrl0: (state) => {
      return state.bonImagePreviewUrl0;
    },
    bonImagePreviewUrl1: (state) => {
      return state.bonImagePreviewUrl1;
    },
    bonImagePreviewUrl2: (state) => {
      return state.bonImagePreviewUrl2;
    },
    simulatePayment: (state) => {
      const sim = (state.androidJsonAppConfig.simulatePayment || 0)
      return 1 === sim
    },
    storePicked: (state) => {
      return state.storePicked;
    },
    softposTerminalState: (state) => {
      return state.softposTerminalState;
    },
    isKiosk: (state) => {
      return state.isKiosk;
    },
    showKioskSplashOnHome: (state) => {
      return state.showKioskSplashOnHome;
    },
    hideSetupButton: (state) => {
      return state.hideSetupButton;
    },

    androidBuildTime: (state) => {
      return state.androidBuildTime;
    },

    bluetoothDevices: (state) => {
      return state.bluetoothDevices;
    },
    allPaymentStores: (state) => {
      return state.allPaymentStores;
    },
    isAndroidKiosk: (state) => {
      return state.isAndroidKiosk;
    },
    androidJsonAppConfig: (state) => {
      return state.androidJsonAppConfig;
    },
    androidJsonAppConfigString: (state) => {
      return JSON.stringify(state.androidJsonAppConfig, null, 2);
    },
    androidKioskUrl: (state) => {
      return state.androidKioskUrl;
    },
    printerLog: (state) => {
      return state.printerLog;
    },
  }
};
